import React from 'react';
import { routes } from '../routes/routes';
import { apiRoutes } from '../api/apiRoutes';
import BusinessIcon from '@mui/icons-material/Business';
import AccountBox from '@mui/icons-material/AccountBox';
import SpellcheckIcon from '@mui/icons-material/Spellcheck';
import Speed from '@mui/icons-material/Speed';
import BadgeIcon from '@mui/icons-material/Badge';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import ContactEmergencyIcon from '@mui/icons-material/ContactEmergency';
import CarRentalIcon from '@mui/icons-material/CarRental';
import AlarmOffIcon from '@mui/icons-material/AlarmOff';
import WorkIcon from '@mui/icons-material/Work';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import AssignmentIcon from '@mui/icons-material/Assignment';
import ReceiptIcon from '@mui/icons-material/Receipt';
import PublicIcon from '@mui/icons-material/Public';
import MoneyOffIcon from '@mui/icons-material/MoneyOff';
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';

export const companySidebarItems = [];

export const sidebarItems = [
  {
    title: 'SIDEBAR.GROUP_GENERAL',
    items: [
      {
        title: 'SIDEBAR.DASHBOARD',
        icon: <Speed />,
        url: routes.admin.dashboard,
      },
      {
        title: 'SIDEBAR.OVERVIEW',
        icon: <PublicIcon />,
        url: routes.admin.orders.overview,
        apiUrl: apiRoutes.orders.getKanban,
      },
      {
        title: 'SIDEBAR.TASKS',
        icon: <AssignmentIcon />,
        url: routes.admin.tasks.schedule,
        apiUrl: apiRoutes.tasks.schedule,
      },
      {
        title: 'SIDEBAR.TASKS',
        icon: <AssignmentIcon />,
        url: routes.admin.tasks.employeeSchedule,
        apiUrl: apiRoutes.tasks.employeeSchedule,
      },
      {
        title: 'SIDEBAR.TIME_OFFS',
        icon: <AlarmOffIcon />,
        url: routes.admin.timeOffs.employeeList,
        apiUrl: apiRoutes.timeOffs.employeeList,
      },
      {
        title: 'SIDEBAR.WORK_LOGS',
        icon: <BadgeIcon />,
        url: routes.admin.employees.employee,
        apiUrl: apiRoutes.employees.employee,
      },
    ],
  },
  {
    title: 'SIDEBAR.GROUP_CLIENTS',
    items: [
      {
        title: 'SIDEBAR.ORDERS',
        icon: <MonetizationOnIcon />,
        url: routes.admin.orders.list,
        apiUrl: apiRoutes.orders.list,
      },
      {
        title: 'SIDEBAR.COMMERCIAL_OFFERS',
        icon: <CurrencyExchangeIcon />,
        url: routes.admin.commercialOffers.list,
        apiUrl: apiRoutes.orders.list,
      },
      {
        title: 'SIDEBAR.INVOICES',
        icon: <ReceiptIcon />,
        url: routes.admin.invoices.list,
        apiUrl: apiRoutes.invoices.list,
      },
      {
        title: 'SIDEBAR.CLIENTS',
        icon: <ContactEmergencyIcon />,
        url: routes.admin.clients.list,
        apiUrl: apiRoutes.clients.list,
      },
      {
        title: 'SIDEBAR.CLIENT_VEHICLES',
        icon: <CarRentalIcon />,
        url: routes.admin.clientVehicles.list,
        apiUrl: apiRoutes.clientVehicles.list,
      },
    ],
  },
  {
    title: 'SIDEBAR.GROUP_EMPLOYEES',
    items: [
      {
        title: 'SIDEBAR.EMPLOYEES',
        icon: <BadgeIcon />,
        url: routes.admin.employees.list,
        apiUrl: apiRoutes.employees.list,
      },
      {
        title: 'SIDEBAR.TIME_OFFS',
        icon: <AlarmOffIcon />,
        url: routes.admin.timeOffs.list,
        apiUrl: apiRoutes.timeOffs.list,
        countApiUrl: apiRoutes.timeOffs.getPendingCount,
      },
    ],
  },
  {
    title: 'SIDEBAR.GROUP_SETTINGS',
    items: [
      {
        title: 'SIDEBAR.SERVICES',
        icon: <WorkIcon />,
        url: routes.admin.items.list,
        apiUrl: apiRoutes.items.listItems,
      },
      {
        title: 'SIDEBAR.VEHICLES',
        icon: <DirectionsCarIcon />,
        url: routes.admin.vehicles.list,
        apiUrl: apiRoutes.vehicles.list,
      },
      {
        title: 'SIDEBAR.COMPANIES',
        icon: <BusinessIcon />,
        url: routes.admin.companies.list,
        apiUrl: apiRoutes.companies.list,
        enabled: process.env.REACT_APP_PLATFORM_ENABLED === 'true',
      },
      {
        title: 'SIDEBAR.EXPENSES',
        icon: <MoneyOffIcon />,
        url: routes.admin.expenses.list,
        apiUrl: apiRoutes.expenses.list,
      },
      {
        title: 'SIDEBAR.USERS',
        icon: <AccountBox />,
        url: routes.admin.users.list,
        apiUrl: apiRoutes.users.list,
      },
      {
        title: 'SIDEBAR.TRANSLATIONS',
        icon: <SpellcheckIcon />,
        url: routes.admin.translations.list,
        apiUrl: apiRoutes.translations.list,
      },
    ],
  },
];

export const sidebarCheckinConfig = {
  enabled: true,
  statusApiUrl: apiRoutes.employeeCheckIn.isCurrentlyActive,
  startLabel: 'EMPLOYEE.CHECK_IN',
  startApiUrl: apiRoutes.employeeCheckIn.checkIn,
  endLabel: 'EMPLOYEE.CHECK_OUT',
  endApiUrl: apiRoutes.employeeCheckIn.checkOut,
};

export const sidebarComponentConfig = {
  component: null,
};
